var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseObject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 597"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.06 12L24.44 12C24.44 6.44 22.74 2.78 19 -6.99382e-07C24.34 1.12 29.66 4.22 30.74 12L35 12L27.54 20L20.06 12Z",
    fill: "#003E6B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 596"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1088",
    y: 28,
    width: 36,
    height: 5,
    fill: "#003E6B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 595"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1089",
    y: 23,
    width: 36,
    height: 3,
    fill: "#003E6B"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1093",
    x: 2,
    y: 24,
    width: 3,
    height: 6,
    fill: "#003E6B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseObject);
export default __webpack_public_path__ + "static/media/close_object.5cf65d2c60b06b5960b44b7d08dd91e9.svg";
export { ForwardRef as ReactComponent };